import { useCurrentTenantQuery } from '@/modules/tenant/hooks/useReadTenant'

export const useTrialStatus = () => {
  const { tenant } = useCurrentTenantQuery()
  return {
    data: tenant ? { daysLeft: tenant.payload.trialDaysLeft } : undefined,
  }
}
